<template>
	<div>
		<a-modal :title="audit ? '领用审批' : '领用申请详情'" class='gufiiguy' :visible="is_show" width="60%" @cancel="is_show = false" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="is_show = false"> 取消 </a-button>
				<a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
				<a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
				<a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
			</template>
			<div ref="sadsada">
			<a-form-model :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
				<div class="title">
					<span>基本信息</span>
				</div>
				<div class="content">
					<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批标题" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span>{{ info.title }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="申领单号" class="model_span_form"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
								<span>{{ info.claimCode }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="抄送人" class="model_span_form"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
								<span>{{ info.ccName }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="申领标题" class="model_span_form">
								<span>{{ info.title }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="申领日期" class="model_span_form">
								<span>{{ info.createTime }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="申 领 人 " class="model_span_form">
								<span>{{ info.applyer }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="物品用途" class="model_span_form">
								<span>{{ info.reason }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="申领备注" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
								<span>{{ info.remark }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
				</div>
				<div class="title">
					<span>物品信息</span>
				</div>
				<div class="content" style="padding: 10px 20px 30px 20px;">
					<a-row>
						<a-table :data-source="info.goods" bordered :pagination="false" style="margin-top: 15px">
							<a-table-column key="name" title="物品名称" data-index="name">
								<template scope="text,record">{{ record.aaSpu.name }}</template>
							</a-table-column>
							<a-table-column key="model" title="规格型号" data-index="model">
								<template scope="text,record">{{ record.aaSpu.model }}</template>
							</a-table-column>
							<a-table-column key="isInspected" title="是否检定" data-index="isInspected">
								<template scope="text,record">
									<span :style="{ color: colors[record.aaSpu.isInspected] }">{{
					  instrumentMap[record.aaSpu.isInspected]
					}}</span>
								</template>
							</a-table-column>
							<a-table-column key="claimNum" title="申领数量" data-index="claimNum">
								<template scope="text,record">{{ record.claimNum }}</template>
							</a-table-column>
							<a-table-column key="unit" title="物品单位" data-index="unit">
								<template scope="text,record">{{ record.aaSpu.unit }}</template>
							</a-table-column>
						</a-table>
					</a-row>
				</div>
				<div class="title" v-if="!audit && recordNumber==1">
                   <span>审批记录</span>
                </div>
                <div class="content" v-if="!audit && recordNumber==1">
                   <auditModel ref="auditModel"></auditModel>
                </div>
				<!-- <a-row>
					<a-col :span="12" v-if="audit">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							<a-textarea placeholder="请输入" v-model="comment" :auto-size="{ minRows: 2, maxRows: 6 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12" v-if="record.comment != undefined">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							{{ record.comment }}
						</a-form-model-item>
					</a-col>
				</a-row> -->
			</a-form-model>
			</div>
		</a-modal>
		<!-- 撤销提示 -->
		<a-modal v-model="is_revocation" :title="result==3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'" on-ok="handleOkReason">
			<template slot="footer">
				<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result==3"> 驳回 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result==2"> 通过 </a-button>
			</template>
			<a-textarea placeholder="请输入原因" v-model="comment" />
		</a-modal>
		<transferModal ref="transferModal" @sure="handleSure"/>
	</div>
</template>
<script>
    import auditModel from './audit.vue'
	import {
		getClaimByBusiness,
		act_task_audit
	} from '@/api/activiti'
	import {
		act_sku_num
	} from '@/api/assetmenag'
	import {
		checkPermission
	} from '@/utils/permissions'
	import transferModal from '@/views/activiti/modules/TransferModal.vue'
	import Watermark from '../../../utils/watermark'
	export default {
		components: {
			transferModal,
			auditModel	
		},
		props: {
			audit: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				is_revocation: false,
				result: '',
				comment: '', //驳回原因
				is_show: false,
				info: {},
				labelCol: {
					span: 9
				},
				wrapperCol: {
					span: 15
				},
				record: null,
				assetsExportConsumables: checkPermission('asset:claim:checkSku'),
			}
		},
		activated() {},
		watch: {},
		created() {},
		mounted() {
			console.log(this.assetsExportConsumables)
		},
		methods: {
			handleSure(){
				this.is_show = false
				this.$emit('ok')
			},
			show(record, type = null) {
				this.recordNumber = record.recordNumber
				this.record = record
				getClaimByBusiness(record.businessKey).then((res) => {
					console.log(res)
					if (res.code != 200) {
						this.$message.error(res.msg)
						return
					}
					this.info = res.data
					this.is_show = true
					this.$nextTick(()=>{
						 if(!this.audit && this.recordNumber) {
                           this.$refs.auditModel.show(record)
                        }
                         Watermark.set('安联云管家' , this.$refs.sadsada)
                    })
				})
			},
			//驳回
			reject(result_) {
				if(result_==1){
					this.$refs.transferModal.show({
					record: this.record,
				})
				}else{
					this.is_revocation = true
					this.comment = ''
					this.result = result_
				}
				
			},
			handleOkReason(){
				if (this.result == 2) {
					if (this.assetsExportConsumables) {
						var lis = []
						this.info.goods.forEach((element) => {
							lis.push({
								spuId: element.aaSpu.id,
								amount: element.claimNum,
								name: element.aaSpu.name,
							})
						})
						act_sku_num(lis).then((res) => {
							if (res.code != 200) {
								this.$message.error(res.msg)
								return
							}
							this.succeed(this.result)
						})
					} else {
						this.succeed(this.result)
					}
				} else if (this.result == 3){
					if (this.comment == '') {
						this.$message.error('请输入驳回意见！')
					} else {
						this.succeed(this.result)
					}
				}
			},
			//审批
			succeed(result_) {
				act_task_audit({
					taskId: this.record.id,
					procDefKey: this.record.processDefKey,
					procInstId: this.record.procInstId,
					procName: this.record.processName,
					applyer: this.record.applyer,
					result: result_,
					businessKey: this.record.businessKey,
					comment: this.comment,
				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.msg)
						return
					}
					this.$message.success('审批成功')
					this.$emit('ok')
					this.is_show = false
					this.is_revocation = false
				})
			},
		},
	}
</script>
<style>
</style>
